/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

interface IParams {
  [key: string]: any,
}

const formValuesToFormObjectCreator = entityConstructor => (formValues: IParams) => {
  const data = new entityConstructor()

  Object.entries(formValues).forEach(([key, value]) => {
    data.append(key, value)
  })
  return data
}

export const getURLSearchParams = formValuesToFormObjectCreator(URLSearchParams)
